import { Segment } from '@mi-front/core';
import { SegmentsStream } from '@mi-front/ui';
import { Box } from '@mui/material';
import { RangeWaveformPlayerMarkers } from './RangeWaveformPlayerMarkers';

export interface RangeWaveformPlayerStreamProps {
  from: number;
  to: number;
  segments: readonly Segment[];
  height: number;
  currentTs: number | null;
  onSeek: (ts: number) => void;
  tz?: string;
}

/**
 * Bounded SegmentsStream with click-to-seek and playhead overlay.
 */
export function RangeWaveformPlayerStream({
  from,
  to,
  segments,
  height,
  currentTs,
  onSeek,
  tz,
}: RangeWaveformPlayerStreamProps) {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        // Reserve stream height before SegmentsStream measures width (avoids collapse to 0).
        minHeight: height,
        position: 'relative',
        overflow: 'hidden',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        boxSizing: 'border-box',
      }}
    >
      <SegmentsStream
        range={{ from, to }}
        segments={segments}
        height={height}
        tz={tz}
        showAxis
        renderHtml={() => (
          <RangeWaveformPlayerMarkers
            from={from}
            to={to}
            currentTs={currentTs}
            onSeek={onSeek}
            tz={tz}
          />
        )}
      />
    </Box>
  );
}
